import Image from 'next/image';

import { StyledH2, StyledPrimaryCell } from '../utils';

export function MovingMarketSection() {
  return (
    <StyledPrimaryCell
      className="rounded-b-[2.25rem] mb-20 pb-5 pt-15 px-11 tablet:px-15 flex-col"
      style={{
        background: `url(/images/limit-orders/diagonal-lines.svg) no-repeat top left, var(--token-color-gray-100)`,
      }}
    >
      <StyledH2 className="block py-2 text-center">
        Limit orders let you <span className="text-token-gray-1000">master a moving market</span>
      </StyledH2>

      <ul className="mt-3.5 desktop:mt-8.5 mb-2.5 tablet:mb-5 desktop:mb-10 flex flex-col tablet:flex-row tablet:flex-wrap justify-center desktop:justify-around">
        <li className="flex flex-col items-center text-center my-5 desktop:my-0 gap-2.5 text-token-gray-800 tablet:w-[220px]">
          <Image src="/images/limit-orders/volatile-days.svg" alt="" width={165} height={80} />
          Volatile days
        </li>
        <li className="flex flex-col items-center text-center my-5 desktop:my-0 gap-2.5 text-token-gray-800 tablet:w-[220px]">
          <Image src="/images/limit-orders/illiquid-markets.svg" alt="" width={165} height={80} />
          Illiquid markets
        </li>
        <li className="flex flex-col items-center text-center my-5 desktop:my-0 gap-2.5 text-token-gray-800 tablet:w-[220px]">
          <Image src="/images/limit-orders/low-cap.svg" alt="" width={165} height={80} />
          Low-cap token positions
        </li>
        <li className="flex flex-col items-center text-center my-5 desktop:my-0 gap-2.5 text-token-gray-800 tablet:w-[220px]">
          <Image
            src="/images/limit-orders/arbitrage-opportunities.svg"
            alt=""
            width={165}
            height={80}
          />
          Arbitrage opportunities
        </li>
      </ul>
    </StyledPrimaryCell>
  );
}
